import React from "react";

import { LineChart, ResponsiveContainer, Line, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

import {
  getRange,
  magnitudeDiff,
  getPrettyNumber,
  ButtonGroup,
  Button,
  softRound,
  OPTIONS as aibleOptions
} from "aible";

import ComplianceGraphContainer from "containers/Monitoring/ComplianceGraph";
import { SUBGROUP_DATA, OVERALL_DATA } from "components/Monitoring/RetrainFrontiers";

import { isEnabled } from "utils/featureFlags";

import { ALERT_TYPES, MONITOR_VIEW_MODES } from "containers/Monitoring/reducer";
import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

import styles from "./style.module.css";

const CustomToolTip = (props) => {
  const { active, payload, dataLabel, unitLabel } = props;
  if (!active || !payload) {
    return null;
  }

  const date = payload[0] && payload[0].payload && payload[0].payload.date;

  payload.sort((a, b) => b.value - a.value);

  return (
    <div className={styles.toolTipWrapper}>
      <div className={styles.toolTopBody}>
        <strong>{date}</strong>
      </div>
      <div style={{ padding: "4px" }} />
      {payload.map((data, i) => {
        if (!data.payload || data.value === undefined) {
          return <div key={"maingraph" + i} />;
        }
        return (
          <div key={"maingraph" + i} className={styles.toolTopBody}>
            <strong>{dataLabel + ": "}</strong>
            <span>{(data.value < 0 ? "-" : "") + unitLabel + Number(Math.abs(data.value)).toLocaleString()}</span>
          </div>
        );
      })}
    </div>
  );
};

export default class MonitoringSparkGraph extends React.PureComponent {
  render() {
    const {
      id,
      segmentId,
      warnings,
      adjustAssumptions,
      monitoringData,
      latestData,
      latestScenario,
      scenarioIndex,
      isContinuous,
      monitorViewMode,
      updateMonitorViewMode,
      userFeedback,
      deleteUserFeedback,
      selectedDataset,
      compliancePlot,
      color,
      setupLabels
    } = this.props;

    if (
      !(
        monitoringData &&
        monitoringData[segmentId] &&
        monitoringData[segmentId].data &&
        monitoringData[segmentId].data.length
      )
    ) {
      return <React.Fragment />;
    }

    const label = latestData && latestData[segmentId] && latestData[segmentId].label;
    const latestSegmentScenarios = latestScenario && latestScenario[segmentId];
    const segmentScenarios = monitoringData && monitoringData[segmentId] && monitoringData[segmentId].scenarios;

    const currentScenario = latestSegmentScenarios && latestSegmentScenarios.selectedScenario;
    const valueKey = isContinuous ? "cost" : "profit";

    const retScenario = segmentScenarios
      ? segmentScenarios.map((elem, i) => {
          const retData = {
            date: elem.date
          };
          elem.scenarios.forEach((scen) => {
            if (currentScenario && scen.index === currentScenario.index) {
              retData.selected = scen[valueKey];
              retData.selectedName = scen.name;
            }
          });
          return retData;
        })
      : [];
    return (
      <ResponsiveContainer height={150}>
        <LineChart height={150} data={retScenario} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
          <Tooltip
            content={<CustomToolTip dataLabel={setupLabels.profitLabel} unitLabel={setupLabels.unitType} />}
            itemStyle={{ fontSize: "14px" }}
            contentStyle={{ fontSize: "14px" }}
            wrapperStyle={{ background: "#FFFFFF" }}
          />
          <Line dataKey={"selected"} stroke={color || "#512F77"} strokeWidth={3} dot={false} />
          <XAxis dataKey={"date"} hide />
          <YAxis tickFormatter={(tick) => getPrettyNumber(tick)} hide />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}
